import React from "react";
import Error from "../components/Error";

const NoPage = () => {
  return (
    <>
      <div className="NoPage">
        <main>
          <Error />
        </main>
      </div>
    </>
  );
};

export default NoPage;